import { Col, List, Row, Card } from "antd";
import { AddressInfo } from "views/Profile/components/viewAddressInfo";
import { AvatarProfile } from "views/Profile/components/viewAvatarProfile";
import { BasicInfo } from "views/Profile/components/viewBasicInfo";
import { EducationItem } from "views/Profile/components/viewEducationItem";
import { ExperienceItem } from "views/Profile/components/viewExperienceItem";
import { CertificateItem } from "./components/viewCertificateItem";
import { CvItem } from "views/Profile/components/viewCvItem";

interface CandidateProfileProps {
  profile: any; 
  coverLetter: string | undefined;
  questionAnswers?: Record<string, string | boolean>;
}

const CandidateProfile: React.FC<CandidateProfileProps> = ({
  profile,
  coverLetter,
  questionAnswers,
}) => {
  // FIX: The profile data is now nested inside the 'applicant_info' object.
  const user = profile.applicant_info;

  // If for some reason the nested object doesn't exist, don't render anything.
  if (!user) {
    return <div>No profile information available.</div>;
  }

  return (
    <div className="bg-background">
      <div className="max-w-6xl mx-5 py-12">
        <Row gutter={[24, 24]} className="mt-3">
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <AvatarProfile user={user} />
          </Col>
          <Col xs={24} sm={24} md={16} lg={16} xl={16}>
            <Card>
              <BasicInfo user={user} />
            </Card>

            {user.languages && (
              <Card className="mt-6" title="Languages">
                {user.languages.length ? user.languages.join(", ") : "N/A"}
              </Card>
            )}

            {user.temporaryAddress && (
              <AddressInfo
                title="Temporary Address"
                address={user.temporaryAddress}
              />
            )}
            {user.permanentAddress && (
              <AddressInfo
                title="Permanent Address"
                address={user.permanentAddress}
              />
            )}

            <Card className="mt-6" title="Educational Background">
              <List
                dataSource={user.educationalBackground || []}
                renderItem={(item) => <EducationItem item={item} />}
              />
            </Card>

            <Card className="mt-6" title="Experience">
              <List
                dataSource={user.experience || []}
                renderItem={(item) => <ExperienceItem item={item} />}
              />
            </Card>

            <Card className="mt-6" title="Certificates">
              <List
                dataSource={user.certificates || []}
                renderItem={(item) => <CertificateItem item={item} />}
              />
            </Card>

            <Card className="mt-6" title="CV">
              <div style={{ textAlign: "left", marginTop: "10px" }}>
                 {/* FIX: The CV data from meilisearch is nested under applicant_info.cv.file */}
                {user.cv?.file ? (
                  <CvItem item={user.cv} />
                ) : (
                  <p style={{ color: "gray", fontStyle: "italic" }}>
                    No CV available
                  </p>
                )}
              </div>
            </Card>

            {questionAnswers && Object.keys(questionAnswers).length > 0 && (
              <Card className="mt-6" title="Questions & Answers">
                {Object.entries(questionAnswers).map(([question, answer]) => (
                  <Row key={question} style={{ marginBottom: 12 }}>
                    <Col span={10}>
                      <strong>{question}</strong>
                    </Col>
                    <Col span={14}>
                      {typeof answer === "boolean"
                        ? answer
                          ? "Yes"
                          : "No"
                        : answer}
                    </Col>
                  </Row>
                ))}
              </Card>
            )}

            <Card className="mt-6" title="Cover Letter">
              <div style={{ textAlign: "left", marginTop: "10px" }}>
                {coverLetter ? (
                  <p>{coverLetter}</p>
                ) : (
                  <p style={{ color: "gray", fontStyle: "italic" }}>
                    No cover letter available
                  </p>
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default CandidateProfile;